<template>
  <keep-alive>
    <b-modal :id="id" ref="modal" :title="modalTitle" no-close-on-backdrop title-class="font-18" v-bind="$attrs"
             @ok="handleOk">
      <validation-observer ref="form_observer">
        <component
            :is="form"
            ref="form"
            v-model="model"
            :errors="errors"
            :is-valid.sync="isValid"
            is-modal="true"
            v-bind="formProps"
            v-on="formListeners"
        >
        </component>
      </validation-observer>
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button :disabled="loading" size="md" variant="primary" @click="ok()">
          <i v-if="loading" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          Simpan
        </b-button>
      </template>
    </b-modal>
  </keep-alive>
</template>

<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/feed.vue";
import Swal from "sweetalert2";

export default {
  extends: ModelCreateModal,
  components: {
    FormsModel,
  },
  props: {
    id: {type: String, required: true},
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t('feeds.singular'))
      }
    },
    resourceRoute: {default: 'models'},
    modelVariable: {default: 'model'},
    form: {
      type: Object, default: function () {
        return FormsModel;
      }
    },
    formProps: {
      type: Object, default: function () {
        return {}
      }
    },
    formListeners: {
      type: Object, default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object, default() {
        return {}
      }
    },
    denyCustomerSelect: {
      type: Boolean, default: () => false
    }
  },
  data() {
    return {
      loading: false,
      isValid: true,
      model: {
        ...this.initialValue,
      },
      errors: {},
    }
  },

  methods: {
    handleStore() {
      return this.$axios.post('/v1/feed_products', this.$refs.form.model)
    },
    handleOk(event) {
      event.preventDefault()
      this.loading = true
      return this.handleStore()
          .then((result) => {
            const data = result?.data?.data

            if (data) {
              let id = (data || {}).id;
              return Swal.fire({
                title: this.$t('Success') + '!',
                text: this.$t(`You've added {something} with id {id}`, {
                  something: this.$t('feeds.singular'),
                  id
                }),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.$emit('created', data)
                this.$refs.modal.hide()
              })
            }
          }).catch((error) => this.failedAlert(error))
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>


<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #0084F3;
  }

  .modal-dialog {
    max-width: 720px !important;
  }

  .col-form-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #6C7589;
  }
}
</style>